<script setup lang="ts">
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/stores/auth';
import { initFullscreen } from '@/utils/fullscreen';

const router = useRouter();
const auth = useAuthStore();

onMounted(() => {
  window.addEventListener('auth:unauthorized', () => {
    auth.logout();
    router.replace({ name: 'login' });
  });

  // 移动端全屏管理（首次触摸自动请求全屏）
  initFullscreen();
});
</script>

<template>
  <router-view />
</template>
